<template>
  <div :class="$options.name">
    <v-dialog v-model="dialog" max-width="500px">
      <template #activator="{ on }">
        <v-btn
          color="primary"
          dark
          class="elevation-0"
          v-on="on"
        >
          Добавить дату
        </v-btn>
      </template>

      <v-card>
        <v-card-title>Новая дата</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="6" class="pt-0">
                <v-menu
                  ref="menu1"
                  v-model="dateMenuState"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateValue"
                      label="Дата события"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="dateValue"
                    locale="ru"
                    no-title
                    :first-day-of-week="1"
                    @input="dateMenuState = false"
                  />
                </v-menu>
              </v-col>

              <v-col md="6" class="pt-0">
                <v-menu
                  ref="menu"
                  v-model="timeMenuState"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="timeValue"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="timeValue"
                      label="Время события"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="timeMenuState"
                    v-model="timeValue"
                    format="24hr"
                    full-width
                    @click:minute="$refs.menu.save(timeValue)"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" dark @click="onCreate">Создать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'new-history-element',
  data: () => ({
    dateValue: null,
    timeValue: null,
    dateMenuState: false,
    timeMenuState: false,
    dialog: false,
  }),
  methods: {
    onCreate() {
      if (!this.dateValue || !this.timeValue) return;
      this.$emit('submit', { date: this.dateValue, time: this.timeValue });
      this.dialog = false;
    },
  },
};
</script>

<style scoped>

</style>
